// extracted by mini-css-extract-plugin
export default {"aside":"SideBarAdmin_aside__u+T0-","dashboardLink":"SideBarAdmin_dashboardLink__eY7fk","active":"SideBarAdmin_active__E2r4q","highlight":"SideBarAdmin_highlight__o0ewD"};